import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateFile, deleteBulkFile, moveBulkFile, markBulkFilesAsRead } from 'services/fileManager/fileManagerServices';
import { queryKeys } from 'hooks/config/queryClient';

export default function useUpdateFiles() {
  const queryClient = useQueryClient();

  const updateFilesMutation = useMutation({
    mutationFn: (payload) => updateFile(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.fileManager.lists() }),
  });

  const fileBulkDeleteMutation = useMutation({
    mutationFn: ({ data, operation, is_lead }) => deleteBulkFile(data, operation, is_lead),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.fileManager.lists() }),
  });

  const fileBulkMoveMutation = useMutation({
    mutationFn: ({ data, operation, is_lead }) => moveBulkFile(data, operation, is_lead),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.fileManager.lists() }),
  });

  const fileBulkMarkAsReadMutation = useMutation({
    mutationFn: (payload) => markBulkFilesAsRead(payload),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.fileManager.lists() }),
  });

  const updateFiles = (payload) => updateFilesMutation.mutateAsync(payload);
  const fileBulkDelete = (data, operation, is_lead) => fileBulkDeleteMutation.mutateAsync({ data, operation, is_lead });
  const fileBulkMove = (data, operation, is_lead) => fileBulkMoveMutation.mutateAsync({ data, operation, is_lead });
  const fileBulkMarkAsRead = (payload) => fileBulkMarkAsReadMutation.mutateAsync(payload);

  return { updateFiles, fileBulkDelete, fileBulkMove, fileBulkMarkAsRead };
}
